import Lightbox from '@stimulus-components/lightbox'

export default class extends Lightbox {
  connect() {
    super.connect()
  }

  get defaultOptions() {
      return {
        selector: ".gallery-item",
        mobileSettings: { showCloseIcon: true } 
      } 
  }
}
